<template>
  <div v-if="isVisibleInternal" class="modal fade show" id="staticBackdrop" data-bs-backdrop="static"
       data-bs-keyboard="false" tabindex="-1" aria-labelledby="staticBackdropLabel" aria-hidden="true"
       style="display:block;">
    <div class="modal-dialog" :class="props.modalWidth">
      <div class="modal-content">
        <div class="modal-header">
          <h1 class="modal-title fs-5" id="staticBackdropLabel">{{ props.title }}</h1>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"
                  @click="closeModal"></button>
        </div>
        <div class="modal-body">
          <slot></slot>
        </div>
        <div class="modal-footer">
          <slot name="footer">
            <button type="button" class="btn btn-danger" data-bs-dismiss="modal" @click="closeModal">{{ props.closeButtonText }}</button>
            <button type="button" class="btn btn-success" :disabled="!props.saveAllowed" @click="saveModal">
              {{ props.saveButtonText }}
            </button>
          </slot>
        </div>
      </div>
    </div>
  </div>
  <div v-if="isVisibleInternal" class="modal-backdrop fade show"></div>
</template>

<script setup>
import { ref, watch, onMounted, onBeforeUnmount, defineProps, defineEmits } from 'vue';

const props = defineProps({
  title: {
    type: String,
    default: 'Modal'
  },
  isVisible: Boolean,
  saveAllowed: {
    type: Boolean,
    default: true
  },
  modalWidth: {
    type: String,
    default: 'modal-lg'
  },
  closeOnEsc: {
    type: Boolean,
    default: true
  },
  closeButtonText: {
    type: String,
    default: 'Zavřít'
  },
  saveButtonText: {
    type: String,
    default: 'Uložit změny'
  }
});

const emit = defineEmits(['update:isVisible', 'modal-status', 'save']);

const isVisibleInternal = ref(props.isVisible);
const status = ref('closed');

const closeModal = () => {
  isVisibleInternal.value = false;
  status.value = 'closed';
  emitStatus();
  emit('update:isVisible', false);
};

const saveModal = () => {
  status.value = 'saved';
  emitStatus();
  emit('save');
  closeModal();
};

const emitStatus = () => {
  emit('modal-status', status.value);
};

const handleEscKey = (event) => {
  if (props.closeOnEsc && event.key === 'Escape' && isVisibleInternal.value) {
    closeModal();
  }
};

watch(() => props.isVisible, (newVal) => {
  isVisibleInternal.value = newVal;
  if (newVal) {
    status.value = 'opened';
  } else {
    status.value = 'closed';
  }
  emitStatus();
});

onMounted(() => {
  document.addEventListener('keydown', handleEscKey);
  emitStatus();
});

onBeforeUnmount(() => {
  document.removeEventListener('keydown', handleEscKey);
});
</script>

<style scoped>
/* Potřebné styly pro backdrop */
:deep(.modal-backdrop) {
  opacity: 0.5;
}

/* Doplňující styly pro modal šířky */
.modal-lx {
  max-width: 1000px;
}
</style>